import styled, { css } from 'styled-components'

import { buttonColorCSS } from './utils'
import { BaseButton } from '../BaseButton'

export const TertiaryButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.tertiary

    return css`
      ${buttonColorCSS(button, { loader: 'hidden' })}
      box-shadow: none;

      &:hover,
      &:active {
        box-shadow: none;
      }
    `
  }}
`
